export const TRACKING_ELEMENTS = {
    signInDropdown: 'SignInDropdown',
};

export const GA_ACTION_TEXT = {
    showPatientSplitLoginAndSignup: 'Show Patient Split Login And Signup',
    showPatientDefaultLoginAndSignup: 'Show Patient Default Login And Signup',
};
